// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"chart-ring-1"},"nodeName":"g","children":[{"attributes":{"id":"fill2","fill":"transparent","d":"M16.8993 10.9977C17.4534 13.703 15.7095 16.3452 13.0043 16.8993C10.299 17.4534 7.65679 15.7095 7.10268 13.0043C6.54858 10.299 8.29243 7.65679 10.9977 7.10268C13.703 6.54858 16.3452 8.29243 16.8993 10.9977Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M9.99392 2.2041C4.5834 3.31231 1.09569 8.59679 2.2039 14.0073C3.31211 19.4178 8.59659 22.9055 14.0071 21.7973C18.1385 20.9511 21.1488 17.6699 21.8478 13.7569M14.0796 2.2168C17.8492 3.01983 20.9744 5.97705 21.7972 9.99429","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M16.8993 10.9977C17.4534 13.703 15.7095 16.3452 13.0043 16.8993C10.299 17.4534 7.65679 15.7095 7.10268 13.0043C6.54858 10.299 8.29243 7.65679 10.9977 7.10268C13.703 6.54858 16.3452 8.29243 16.8993 10.9977Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-chart-ring-1')
export default class ChartRing1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chart-ring-1',
    }
  }
}
